export default "__VITE_ASSET__D79oLoXV__"